// @ts-nocheck
import SceneLayerTile from "./tile";

export default class SceneLayerTurist extends SceneLayerTile {
	/**
	 * Vytvoreni turisticke vrstvy.
	 *
	 * @param  {String|Number} id Volitelne ID
	 * @param  {String} url URL pro tahani dlazdic
	 * @param  {Object} [options] Volitelny objekt pro nastaveni vrstvy
	 */
	constructor(scene, itemId, id, url?, options?) {
		super(scene, itemId, id, url, options);

		this._bike = false;
		this._trail = false;
	}

	/**
	 * Informace ohledne entity ve scene.
	 *
	 * @return {Object}
	 */
	// eslint-disable-next-line class-methods-use-this
	get featureInfo() {
		return {
			name: "SceneLayerTurist",
			type: "layer",
		};
	}

	/**
	 * Souhrn vsech dat, ktere vyuziva visualiser pri vytvoreni.
	 *
	 * @return {Object}
	 */
	getCreateData() {
		const rd = super.getCreateData();

		rd.bike = this._bike;
		rd.trail = this._trail;

		return rd;
	}

	/**
	 * Nastaveni priznaku - kolo.
	 *
	 * @param {Boolean} state Priznak
	 */
	setBike(...args) {
		this._bike = args[0];

		this._onChange(this._scene.featureEvent("layerTuristSetBike", true, true), args);

		return this;
	}

	/**
	 * Nastaveni priznaku - stezka.
	 *
	 * @param {Boolean} state Priznak
	 */
	setTrail(...args) {
		this._trail = args[0];

		this._onChange(this._scene.featureEvent("layerTuristSetTrail", true, true), args);

		return this;
	}
}
